import { GrowthToolService, GrowthToolServiceKey } from '@type-def_iqfu/dashboard/GrowthTool';

export const growthToolServices: Record<GrowthToolServiceKey, GrowthToolService> = {
  lp: {
    menuLabel: '売却LP',
    name: '売却LP',
    externalUrl: 'https://cslp.iqra-biz.com/baikyaku-lp/',
  },
  ai: {
    menuLabel: 'AI査定',
    name: 'AI査定',
    externalUrl: 'https://cslp.iqra-biz.com/ai-satei/',
  },
  kuchikomi: {
    menuLabel: '口コミ獲得',
    name: '口コミ獲得',
    externalUrl: 'https://cslp.iqra-biz.com/review-service/',
  },
  interview: {
    menuLabel: 'インタビュー記事',
    name: 'インタビュー記事',
    externalUrl: 'https://cslp.iqra-biz.com/interview-lp/',
  },
};

export const growthToolServiceKeys = Object.keys(growthToolServices) as GrowthToolServiceKey[];
